var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-loading",class:{ 'i-loading-fix': _vm.fix }},[_c('img',{staticClass:"i-loading-img",attrs:{"src":"https://i0.hdslb.com/bfs/activity-plat/static/20210416/d72cd055e5397bb5587804649580b870/OV3xRWIVjL.gif"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }